export { default } from './ServerStyleSheets';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/ServerStyleSheets/index.js
// module id = 908
// module chunks = 2